import Vue from "vue";
import bugsnag from '@bugsnag/js'
import bugsnagVue from '@bugsnag/plugin-vue'
import "./plugins/vuetify";
import App from "./App.vue";
import VueRouter from "vue-router";
import VueResource from "vue-resource";
import Vuex from "vuex";
import VuexPersistence from 'vuex-persist';
import "./filters";
import AuthorPage from "./pages/AuthorPage";
import ReaderPage from "./pages/ReaderPage";
import SnapsPage from "./pages/SnapsPage";
import FriendsPage from "./pages/FriendsPage";
import ReadLeaderboardPage from "./pages/ReadLeaderboardPage";
import PublishPage from "./pages/PublishPage";
import AddPublishPage from "./pages/AddPublishPage";
import BrowseBooksPage from "./pages/BrowseBooksPage";
import BookPage from "./pages/BookPage";
import AddBookPage from "./pages/AddBookPage";
import EditBookPage from "./pages/EditBookPage";
import AssignmentPage from "./pages/AssignmentPage";
import YourTweetsPage from "./pages/YourTweetsPage";
import PromoteTweetsPage from "./pages/PromoteTweetsPage";
import SignInPage from "./pages/SignInPage";
import Gate from "./pages/Gate";
import Back from "./modules/Back";
import Vuelidate from 'vuelidate';
import Toasted from 'vue-toasted';
import "./sass/main.scss";

Vue.config.productionTip = false;

const bugsnagClient = bugsnag('d46c91642709d531f68a4870218fe2e9');
bugsnagClient.use(bugsnagVue, Vue);

Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(Vuelidate);
Vue.use(Toasted);
Vue.http.options.root = "http://127.0.0.1:8000/api/";

const vuexLocal = new VuexPersistence({
	storage: window.sessionStorage
});

const store = new Vuex.Store({
	state: {
		user: null,
		books: [],
		assignments: [],
		events: [],
		allowedCountries: [],
		reviewIssues: [],
		readingLimit: 1,
		weeklyReadingLimit: 10,
		reviewSearchLimit: 6,
		genres: [],
		languages: [],
		currentBookId: null,
		selectedAssignment: null,
		points: 1000,
		choosingReview: null,
		showFindBook: false,
		showReferProgram: false,
		showTurnInReview: false,
		showSubmitReviewLink: false,
		showCancelAssignment: false,
		showCancelReview: false,
		showNotifications: false,
		showProfileMenu: false,
		suspensionMessage: null,
	},
	mutations: {
		handshake(state, user) {
			state.user = user;
			state.points = user.points;
			state.books = user.books;
			state.assignments = user.assignments;
			state.events = user.events;
			state.suspensionMessage = user.suspension_message;
		},
		setCountries(state, allowedCountries) {
			state.allowedCountries = allowedCountries
		},
		setReviewIssues(state, reviewIssues) {
			state.reviewIssues = reviewIssues
		},
		setReadingLimit(state, readingLimit) {
			state.readingLimit = readingLimit
		},
		setWeeklyReadingLimit(state, weeklyReadingLimit) {
			state.weeklyReadingLimit = weeklyReadingLimit
		},
		setReviewSearchLimit(state, reviewSearchLimit) {
			state.reviewSearchLimit = reviewSearchLimit
		},
		setGenres(state, genres) {
			state.genres = genres
		},
		setLanguages(state, languages) {
			state.languages = languages
		},
		addPoints(state, points) {
			state.points = state.points + points;
		},
		changeCurrentBook(state, book) {
			state.currentBookId = book.id;
		},
		selectAssignment(state, assignment) {
			state.selectedAssignment = assignment;
		},
		closeAssignment(state) {
			state.selectedAssignment = null;
		},
		increment(state) {
			state.count++;
		},
		startChoosingReview(state, book) {
			state.choosingReview = book.id;
		},
		toggleChoosingReview(state, book) {
			if (state.choosingReview) {
				state.choosingReview = null;
			} else {
				state.choosingReview = book.id;
			}
		},
		stopChoosingReview(state) {
			state.choosingReview = null;
		},
		showFindBook(state) {
			state.showFindBook = true;
		},
		hideFindBook(state) {
			state.showFindBook = false;
		},
		showReferProgram(state) {
			state.showReferProgram = true;
		},
		hideReferProgram(state) {
			state.showReferProgram = false;
		},
		showTurnInReview(state) {
			state.showTurnInReview = true;
		},
		hideTurnInReview(state) {
			state.showTurnInReview = false;
		},
		showSubmitReviewLink(state) {
			state.showSubmitReviewLink = true;
		},
		hideSubmitReviewLink(state) {
			state.showSubmitReviewLink = false;
		},
		showCancelAssignment(state) {
			state.showCancelAssignment = true;
		},
		hideCancelAssignment(state) {
			state.showCancelAssignment = false;
		},
		showCancelReview(state) {
			state.showCancelReview = true;
		},
		hideCancelReview(state) {
			state.showCancelReview = false;
		},
		showNotifications(state) {
			state.showNotifications = true;
		},
		hideNotifications(state) {
			state.showNotifications = false;
		},
		showProfileMenu(state) {
			state.showProfileMenu = true;
		},
		hideProfileMenu(state) {
			state.showProfileMenu = false;
		}
	},
	getters: {
		user: state => state.user,
		bookById: (state) => (id) => {
			if (!state.books) {
				return null;
			}

			// console.log('bookById', state.books);
			for (const b in state.books) {
				if (state.books[b].id === id) {
					return state.books[b];
				}
			}
			return null;
		},
		choosingReview: state => state.choosingReview,
		showFindBook: state => state.showFindBook,
		showReferProgram: state => state.showReferProgram,
		showNotifications: state => state.showNotifications,
		showProfileMenu: state => state.showProfileMenu,
		allowedCountries: state => state.allowedCountries,
		reviewIssues: state=> state.reviewIssues,
		readingLimit: state => state.readingLimit,
		weeklyReadingLimit: state => state.weeklyReadingLimit,
		reviewSearchLimit: state => state.reviewSearchLimit,
		suspensionMessage: state => state.suspensionMessage,
		genres: state => state.genres,
		languages: state => state.languages,
	},
	plugins: []
	//plugins: [vuexLocal.plugin]
});

const routes = [
	{ path: "/author", component: AuthorPage },
	{ path: "/reader", component: ReaderPage },
	{ path: "/help", component: SnapsPage },
	{ path: "/snaps", component: SnapsPage },
	{ path: "/publish", component: PublishPage },
	{ path: "/publish/add/:name", component: AddPublishPage },
	{ path: "/books/add", component: AddBookPage },
	{ path: "/books/edit/:id", component: AddBookPage },
	{ path: "/books/:id", component: BookPage },
	{ path: "/assignments/:id", component: AssignmentPage },
	{ path: "/browse", component: BrowseBooksPage },
	{ path: "/social", component: YourTweetsPage },
	{ path: "/social/promote", component: YourTweetsPage },
	{ path: "/social/earn", component: PromoteTweetsPage },
	{ path: "/friends", component: FriendsPage },
	{ path: "/read/leaderboard", component: ReadLeaderboardPage },
	{ path: "/signin", component: SignInPage },
	{ path: "/gate", component: Gate },
	{ path: '/', redirect: '/author' }
];
const router = new VueRouter({
	routes
});
router.beforeEach((to, from, next) => {
	document.title = 'Pubby';
	next()
});

// if (!store.state.user) {
// 	router.push("/signin");	
// }

import Vuetify from "vuetify";
import colors from "vuetify/es5/util/colors";

Vue.use(Vuetify, {
	theme: {
		primary: colors.blue, // #E53935
		secondary: colors.grey, // #FFCDD2
		accent: colors.blue // #3F51B5
	}
});

new Vue({
	render: h => h(App),
	store,
	router
}).$mount("#app");